import React, { useEffect } from "react";
import {
	Button,
	Label,
	Card,
	Checkbox,
	// Grid,
	Input,
	Rating,
} from "semantic-ui-react";
import {
	ErrorMessage,
	Form,
	Field,
	// FieldArray,
	Formik,
	useField,
} from "formik";

import * as Yup from "yup";
import agent from "../../api/agent";
import {
	ModalWithContextProvider,
	useModalWithContext,
} from "../../layouts/ModalWithContext";
import feedbackdata, { feedbackCsvHeaders } from "../../shared/FeedbackData";
import { COMPANY_EMAIL } from "../../shared/Literals";
import { useAuth } from "../../providers/AuthProvider";

const RatingField = ({
	field: name,
	...props
}: {
	field: any;
	name: string;
}) => {
	const [field, meta, helpers] = useField(name);

	return (
		<div className="custom-rating">
			<Rating
				{...field}
				{...props}
				onRate={(e, { rating }) => helpers.setValue(rating)}
			/>
			<div className="rating-numbers">
				{Array.from({ length: 10 }, (_, i) => (
					<span key={i} className="rating-number">
						{i + 1}
					</span>
				))}
			</div>
			{meta.touched && meta.error ? (
				<Label
					basic
					color="red"
					size="tiny"
					style={{ padding: "0px", border: "none", display: "block" }}>
					{meta.error}
				</Label>
			) : null}
		</div>
	);
};
export const TextInputField = ({
	field: name,
	...props
}: {
	field: any;
	name: string;
}) => {
	const [field, meta, helpers] = useField(name);

	return (
		<>
			<Input
				labelPosition="left"
				{...field}
				{...props}
				type={"text"}
				value={field.value ? field.value : field.value === 0 ? "0" : ""}>
				<textarea {...field} rows={4} cols={50} />
			</Input>
			{meta.touched && meta.error ? (
				<Label
					basic
					color="red"
					size="tiny"
					style={{ padding: "0px", border: "none", display: "block" }}>
					{meta.error}
				</Label>
			) : null}
		</>
	);
};

export const FeedbackForm = ({
	formDispatcher,
}: {
	formDispatcher: Function | undefined;
}) => {
	//use a separate dispacher for the modal that will show upon success or failure of feedback submission.
	//This way, the feedback form will not be affected by the closing of the that modal, since it has a different dispatch, formDispatcher
	const { modalDispatcher } = useModalWithContext();
	const { user } = useAuth();

	const closeModal = () => {
		formDispatcher && formDispatcher({ open: false });
	};

	const [isLoading, setIsLoading] = React.useState<boolean>(false);
	const [submitSuccess, setSubmitSuccess] = React.useState<any>(false);

	useEffect(() => {
		if (submitSuccess) {
			const thankMsg =
				"We will contact you soon. A copy of your request has been sent to your email.\n\n" ;

			formDispatcher &&
				formDispatcher({
					open: true,
					size: "tiny",
					displayType: "info",
					options: {
						title: "Thank you",
						body: thankMsg,
						basicModal: true,
					},
				});
		}
	}, [submitSuccess]);

	const [validateSchema, setValidateSchema] = React.useState<any>(
		Yup.object({
			reasonForRequest: Yup.string().required("Required"),
		})
	);

	const objToCSV = (obj: any) => {
		delete obj["error"];
		//get the keys of the object, but do not change the order of the keys
		let headers: string[] = []; // Object.keys(obj);
		let values: string[] = [];


		headers.push("Please briefly describe the reason for your request and intended use (mandatory)");
		values.push(obj["reasonForRequest"] || "");


		let csv = headers.join(",") + "\n" + values.join(",");


		return csv;
	};

	const handleFormSubmit: Function = async (
		values: any,
		setErrors: Function
	) => {
		// console.log(values);
		const msg = messageBody(values);
		try {
			setIsLoading(true);
			await agent.DataRequestMessage.send({
				title: "ESVD Full Database Access Request Form",
				body: msg,
				attachmentString: objToCSV(values),
			})
				.then(() => {
					setSubmitSuccess(true);

					setIsLoading(false);
				})
				.catch((err) => {
					throw err;
				});
		} catch (error: any) {
			setSubmitSuccess(false);
			modalDispatcher &&
				modalDispatcher({
					open: true,
					size: "tiny",
					displayType: "error",
					options: {
						title: "Something happened...",
						body: `There was a problem sending your feedback. \nPlease try again or contact the ESVD Team at ${COMPANY_EMAIL}`,
						basicModal: true,
					},
				});
			setIsLoading(false);
		}
	};

	const messageBody = (frmData: any) => {
		//
		let msg = `<div style={{ marginBlockStart: "0em", padding: "0em 2.5em", marginBottom:"1em" }}>
						<br />
				
		</div>
		<ul>
			<li>${"Display name: "}${user?.displayName}</li>
			<li>${"Email: "}${user?.email}</li>
			<li>${"Organization: "}${user?.organization}</li>
			<li>${"Sector: "}${user?.sector}</li>
			<li>${"Purpose of access: "}${user?.purposeOfAccess} ${user?.purposeOfAccessOther ? user.purposeOfAccessOther : ""}</li>
			<li>${"Reason for your request: "}${frmData["reasonForRequest"]}</li>
		</ul>		
		`;

		return msg;
	};

	const processIssueOptions = (frmData: any) => {
		//
		const options = feedbackdata.issue.options;
		let msg = "\t";
		let isIssue = false;
		if (frmData["issueLoadingTables"]) {
			msg += options.issueLoadingTables + "<br/><br/>";
			isIssue = true;
		}

		if (frmData["issueLoadingMapResult"]) {
			msg += "\t" + options.issueLoadingMapResult + "<br/><br/>";
			isIssue = true;
		}

		if (frmData["issueLoadingSumStart"]) {
			msg += "\t" + options.issueLoadingSumStart + "<br/><br/>";
			isIssue = true;
		}

		if (frmData["issueDownload"]) {
			msg += "\t" + options.issueDownload + "<br/><br/>";
			isIssue = true;
		}

		if (frmData["issueLoggin"]) {
			msg += "\t" + options.issueLoggin + "<br/><br/>";
			isIssue = true;
		}

		if (frmData["issueOther"]) {
			msg += "\t" + options.issueOther + "<br/>";
			msg += "<blockquote>" + frmData["issueOtherText"] + "</blockquote>";
			isIssue = true;
		}

		if (!isIssue) {
			msg += "\t" + "undefined" + "<br/>";
		}

		return msg;
	};

	return (
		<Card.Content style={{ overflowY: "auto", height: "100%" }}>
			<Formik
				enableReinitialize={true}
				initialValues={{
					error: null,
					reasonForRequest: "",
				}}
				validationSchema={validateSchema}
				onSubmit={(values, { setErrors }) => {
					handleFormSubmit(values, setErrors);
				}}>
				{({ handleSubmit, errors }) => (
					<Form onSubmit={handleSubmit} className="custom-ui-element">
						<div
							style={{
								marginBlockStart: "0em",
								padding: "0em 2.5em",
								marginBottom: "1em",
							}}>
							Dear {user?.displayName ? user.displayName : user?.userName},
							<br />
						</div>
						<ul style={{ listStyle: 'none'}}>
							<li className="feedback-list">
								<div
									dangerouslySetInnerHTML={{
										__html: ` ${"<strong>By submitting this form, you are contacting us and express your interest to obtain access to the full dataset or access through our API.</strong>"}`,
									}}
								/>
							</li>
							<li className="feedback-list">
								<div
									dangerouslySetInnerHTML={{
										__html: ` ${"Please briefly describe the reason for your request and intended use (mandatory)"}`,
									}}
								/>
								<br />
								<Field name="reasonForRequest" component={TextInputField} />
							</li>
		
						</ul>
						<Button
							className="btn btn-feedback btn-warning"
							floated="left"
							style={{
								marginLeft: "2.5em",
								minWidth: "4em",
								backgroundColor: "#f6da6e",
							}}
							onClick={closeModal}>
							Close
						</Button>
						<Button
							className="btn btn-feedback btn-primary"
							type="submit"
							// primary
							floated="right"
							loading={isLoading}
							style={{
								backgroundColor: "#70bbfd",
								marginRight: "2.5em",
								minWidth: "4em",
							}}>
							Submit
						</Button>
						<ErrorMessage
							name="error"
							render={() => (
								<Label
									style={{ marginBottom: 5, borderColor: "none" }}
									basic
									color="red"
									size="tiny"
									content={errors.error}
								/>
							)}
						/>
					</Form>
				)}
			</Formik>
		</Card.Content>
	);
};

const FeedbackFormWrapper = ({
	formDispatcher,
}: {
	formDispatcher: Function | undefined;
}) => {
	return (
		<ModalWithContextProvider>
			<FeedbackForm formDispatcher={formDispatcher} />
		</ModalWithContextProvider>
	);
};

export default FeedbackFormWrapper;
